/** Tunable parameters of the guided navigation through Gaussian Splats. Distances are in meters, times in seconds. */
export const GUIDED_NAVIGATION_PARAMS = {
  /** Max horizontal distance of the camera from the trajectory */
  corridorRadius: 1.2,
  /** Max vertical distance of the camera from the trajectory */
  tunnelHalfHeight: 0.6,
  /** Distance from the corridor boundary at which the slowdown starts */
  boundaryWarningDistance: 0.5,
  /** Distance from the corridor boundary at which the grid wall starts to appear */
  boundaryGridDistance: 0.9,
  /** Distance from the closest splat at which the slowdown starts */
  splatWarningDistance: 0.5,
  /** Distance from the closest splat at which the grid wall starts to appear */
  splatGridDistance: 1.5,
  /** Distance from the closest splat at which the movement towards it stops */
  splatMinDistance: 0.1,
  /** The higher, the faster the speed drops when approaching a boundary */
  slowdownExponent: 3,
  /** Delay after the camera stopped before it is considered still */
  fadeOutDelay: 0.3,
  /** Duration of the corridor floor fade in */
  fadeInDuration: 0.08,
  /** Duration of the corridor floor fade out */
  fadeOutDuration: 0.25,
  /** Time the corridor floor stays visible after the movement was last constrained */
  constraintHoldTime: 0.05,
  /** Time the grid walls stay visible after the camera last translated towards one or was constrained by one */
  approachHoldTime: 0.1,
  /** Time the corridor floor stays visible after a click on a point that is not allowed */
  deniedClickShowTime: 1,
  /** Nominal height of the camera above the floor, used to walk to a clicked floor point */
  cameraHeight: 1.6,
  /** Distance inside the tunnel boundary where a camera walking to a point that is not allowed stops */
  clickInset: 0.05,
  /** Max vertical distance from the camera of the trajectory segments shown in the corridor floor */
  corridorDisplayRange: 1.5,
  /** Distance of the corridor floor below the camera */
  corridorFloorOffset: 1,
  /** Camera elevation change after which the corridor floor is rebuilt, once the camera stops */
  corridorRebuildThreshold: 0.1,
  /** Min time between two raycasts on the splats */
  raycastInterval: 0.1,
  /** Max distance of the raycasts on the splats */
  raycastRange: 2,
  /** Min spacing between the trajectory points used to build the corridor */
  segmentSpacing: 0.25,
} as const;
